export const uniqueArray = (array, key) => {
    return array.filter((item, i) => {
        return array.findIndex(item2 => {
            return item[key] === item2[key];
        }) === i;
    });
}



// WEBPACK FOOTER //
// ./src/header/libs/util.js